enum FileReaderApiMethods {
    readAsArrayBuffer = 'readAsArrayBuffer',
    readAsBinaryString = 'readAsBinaryString',
    readAsDataURL = 'readAsDataURL',
    readAsText = 'readAsText',
}
export const FileReaderHelper = {
    readBy(funcName: FileReaderApiMethods, file: File) {
        const reader = new FileReader();

        return new Promise<string>((resolve, reject) => {
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = () => reject(reader.error);
            reader[funcName](file);
        });
    },
    readFileAsText(file: File) {
        return FileReaderHelper.readBy(FileReaderApiMethods.readAsText, file);
    },

    getFileName(file: File) {
        const separator = '.';
        return file.name
            .normalize('NFC')
            .split(separator)
            .slice(0, -1)
            .join(separator);
    },
};
